import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { TemplateId } from '@types';
import useToggle from '@hooks/useToggle';
import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedScene } from '@stores/loadedStore';
import { $templateId } from '@stores/dataStores';
import { $uiCategoryShow } from '@stores/uiStores';
import VideoController from './VideoController';

interface Props {
  videoPlaying: boolean;
}

function VideoControls({ videoPlaying }: Props) {
  const playBtn = useToggle(true);
  const templateId = useStore($templateId);
  const isCategoryShow = useStore($uiCategoryShow);
  const loadedScene = useStore($loadedScene)!;
  const krpPlayer = MainPlayer.get();

  useEffect(() => {
    playBtn.on();
  }, [loadedScene?.materialId]);

  if (!krpPlayer) return null;
  if (!loadedScene) return null;
  if (templateId === TemplateId.realEstateA && isCategoryShow) return null;

  return (
    <VideoController
      sceneData={loadedScene}
      krpPlayer={krpPlayer!}
      videoPlaying={videoPlaying}
    />
  );
}

export default VideoControls;
